module.exports = __webpack_public_path__ + "img/machine_rent.1187d0a1.png";